import axios, {} from 'axios';
const fetcher = async (url, headers) => {
    const response = await fetch(url, { headers });
    if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Network error');
    }
    return response.json();
};
export default fetcher;
export const axiosPostFetcher = async (url, params, config) => {
    const { data } = await axios.post(url, params, config);
    return data;
};
//# sourceMappingURL=fetcher.js.map